import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import Renderable from '../../../Component/Renderable';
import AnimationClip from '../AnimationClip';
import { delay } from '../../../Utility/Task/TaskQueue';

export class SpeechBubblePopUp extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        const renderable: Renderable = gameObject.getComponent(Renderable);

        transform.scale.set(0, 0);
        renderable.visible = true;
        renderable.alpha = 1;

        const popupTween = this.getTween(transform.scale);
        const fadeoutTween = this.getTween(renderable);

        popupTween.to({ x: 1, y: 1 }, 300).easing(Easing.Quadratic.Out);
        fadeoutTween.to({ alpha: 0 }, 300).easing(Easing.Linear.None);

        yield* this.startTween(popupTween);
        yield* delay(2000);
        yield* this.startTween(fadeoutTween);
    }
}
